/** @file importToast: the toast of a template clip import — what was imported, what was skipped. */
import type { TemplateClipsImportReply } from '@zilo/pose3d-api/types/restAdded';

/** "9 clips imported", "3 skipped: idle, walk, run already exist", both joined, or that there was nothing to import. */
export function importToast(r: Pick<TemplateClipsImportReply, 'imported' | 'skipped'>): string {
  const n = r.imported.length;
  const imported = n === 0 ? [] : [`${String(n)} clip${n === 1 ? '' : 's'} imported`];
  const m = r.skipped.length;
  const skipped = m === 0 ? [] : [`${String(m)} skipped: ${r.skipped.join(', ')} already exist${m === 1 ? 's' : ''}`];
  const parts = [...imported, ...skipped];
  return parts.length === 0 ? 'The template has no clips to import' : parts.join('; ');
}
